/**
 * @param {import("../../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/bookings",
    },
    (router) => {
      router.push({
        id: "@api-legacy/booking@search",
        path: "",
      });

      router.group(
        {
          path: "/:bookingId",
        },
        (router) => {
          router.push({
            id: "@api-legacy/booking@view",
            path: "",
          });

          router.group(
            {
              path: "/action",
            },
            (router) => {
              router.push({
                id: "@api-legacy/booking@cancel",
                path: "/cancel",
              });

              router.push({
                id: "@api-legacy/booking@restore",
                path: "/restore",
              });

              router.push({
                id: "@api-legacy/booking@reset-cancellation",
                path: "/reset-cancellation",
              });

              router.push({
                id: "@api-legacy/booking@customer-cancellation",
                path: "/customer-cancellation",
              });

              router.push({
                id: "@api-legacy/booking@owner-cancellation",
                path: "/owner-cancellation",
              });

              router.push({
                id: "@api-legacy/booking@oack",
                path: "/oack",
              });

              router.push({
                id: "@api-legacy/booking@set-oack-settings",
                path: "/set-oack-settings",
              });
            },
          );
        },
      );

      router.group(
        {
          path: "/action",
        },
        (router) => {
          router.push({
            id: "@api-legacy/booking@agent-export",
            path: "/agent-export",
          });
        },
      );
    },
  );
}
